export default __webpack_public_path__ + "static/troopy-anim-2c622f572ab37189840a0261edb365b9.gif";